(function () {
    var MODAL_SEL = '.customily-modal-preview-only';

    function cartButton() {
      return document.querySelector('#customily-cart-btn')
          || document.querySelector('.customily-cart-btn')
          || document.querySelector('.product-form-buttons .add-to-cart-button')
          || document.querySelector('form[action*="/cart/add"] [type="submit"]');
    }

    var CLOSE_FLAG = 'data-cl-closing';
    var CLOSE_MS = 180;                 // khớp với thời lượng trong customily-styles.css
    var closeTimer = null;

    function itMoves() {
      return !(
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    /* Đóng THẬT: app tự dọn trạng thái bên trong nó nên vẫn bấm hộ nút X của app,
       không tự gỡ node. */
    function finishClose(modal) {
      var x = modal.querySelector('.customily-close-button');
      if (x) x.click();
      else modal.style.display = 'none';
      /*
        Gỡ cờ SAU khi đã đóng. Nếu vì lý do gì app không đóng được, gỡ cờ làm
        modal hiện lại nguyên vẹn — thà thế còn hơn để lại một cửa sổ trong suốt
        chắn hết màn hình mà không ai bấm được.
      */
      modal.removeAttribute(CLOSE_FLAG);
    }

    /*
      App đóng modal bằng `display:none`, tức biến mất trong đúng một khung hình.
      Gắn cờ cho CSS chạy hiệu ứng ra trước, hết mới đóng thật.

      `data-cl-closing` cố ý KHÔNG nằm trong attributeFilter của MutationObserver
      bên dưới (nó chỉ theo dõi style/class), nên gắn cờ không kích hoạt
      buildFrame một cách vô ích.
    */
    function closeModal(modal) {
      if (modal.hasAttribute(CLOSE_FLAG)) return;    // đang đóng rồi, đừng chồng
      if (!itMoves()) return finishClose(modal);

      modal.setAttribute(CLOSE_FLAG, '');
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { finishClose(modal); }, CLOSE_MS);
    }

    /*
      Nút X của app đã được chuyển vào đầu thẻ (xem buildFrame), khách bấm thẳng
      vào nó là app đóng ngay, không đi qua closeModal — mất hiệu ứng. Chặn ở
      tầng capture rồi tự lái sang closeModal.

      Khi đã gắn cờ thì cho cú bấm đi qua: chính finishClose gọi `x.click()`.
    */
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var x = t.closest('.customily-close-button');
        if (!x) return;
        var modal = x.closest(MODAL_SEL);
        if (!modal || modal.hasAttribute(CLOSE_FLAG)) return;
        e.preventDefault();
        e.stopPropagation();
        closeModal(modal);
      },
      true
    );

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }

    function buildFrame(modal) {
      var main = modal.querySelector('.main');
      if (!main) return;

      if (!main.querySelector('.cl-preview-head')) {
        var head = el('div', 'cl-preview-head');
        var title = document.querySelector('.product-title, h1');
        head.appendChild(el('span', 'cl-preview-title',
          title && title.textContent.trim() ? title.textContent.trim() : 'Preview your personalization'));
        var x = main.querySelector('.customily-close-button');
        if (x) {
          x.setAttribute('role', 'button');
          x.setAttribute('aria-label', 'Close preview');
          x.setAttribute('tabindex', '0');
          head.appendChild(x);          // chuyển nút X của app vào đầu thẻ
        }
        main.insertBefore(head, main.firstChild);
      }

      var foot = main.querySelector('.cl-preview-foot');

      /* Modal này dùng cho hai luồng. Khi mở từ nút Preview (không có cờ
         data-cl-edit-mode) thì phải là Keep editing / Add to cart, kể cả khi
         lần trước nó đã bị luồng chỉnh ảnh đổi thành Replace / Done. */
      var editMode = modal.hasAttribute('data-cl-edit-mode');
      if (foot && !editMode && foot.dataset.clMode !== 'preview') {
        foot.remove();
        foot = null;
      }

      if (!foot && !editMode) {
        foot = el('div', 'cl-preview-foot');
        foot.dataset.clMode = 'preview';

        var backBtn = el('button', 'cl-preview-btn cl-preview-btn--secondary', 'Keep editing');
        backBtn.type = 'button';
        backBtn.addEventListener('click', function () { closeModal(modal); });

        var addBtn = el('button', 'cl-preview-btn cl-preview-btn--primary', 'Add to cart');
        addBtn.type = 'button';
        addBtn.addEventListener('click', function () {
          var real = cartButton();
          if (!real) return;           // không thấy nút thật thì giữ modal, đừng đóng câm lặng

          /*
            BẤM NGAY, ĐỪNG ĐỢI MODAL ĐÓNG XONG.

            Bản trước đợi `CLOSE_MS + 80` rồi mới bấm, vì sợ modal xác nhận giỏ
            hàng chồng lên lúc modal này còn đang mờ dần. Đo luồng thật thì nỗi
            sợ đó thừa: sau cú bấm, Customily còn lưu ảnh preview (~1,5s) rồi
            đặt file in EPS (~0,4s), xong mới POST vào giỏ (~1s) — modal xác
            nhận mãi ~4 giây sau mới hiện, trong khi modal này biến mất ở 183ms.
            Hai cái cách nhau cả một quãng dài, không có gì để chồng.

            Nên bấm ngay và để hiệu ứng đóng chạy song song: tiết kiệm 260ms
            thật, không đánh đổi gì.

            Cú bấm này cũng là thứ kích hoạt `markPending()` bên
            cart-added-modal.js — nút mua trên trang sẽ quay vòng chờ suốt 4
            giây đó, nên khách không bị nhìn vào một trang đứng im.
          */
          real.click();
          closeModal(modal);

          /*
            Kéo nút mua vào tầm nhìn nếu nó đang nằm ngoài — `block: 'nearest'`
            không làm gì khi nút đã hiện sẵn, nên trường hợp thường gặp không bị
            giật trang. Không có dòng này thì khách cuộn xa sẽ chờ 4 giây mà
            không thấy vòng quay ở đâu cả.
          */
          if (real.scrollIntoView) real.scrollIntoView({ block: 'nearest' });
        });

        foot.appendChild(backBtn);
        foot.appendChild(addBtn);
        main.appendChild(foot);
      }
      /* Ở chế độ chỉnh ảnh, chân thẻ do snippet customily-edit-modal dựng nên
         ở đây foot là null — phải kiểm trước khi dùng, nếu không ném lỗi
         "appendChild: parameter 1 is not of type 'Node'". */
      if (foot) {
        // App gắn phần xem trước vào .main sau khi mở, giữ chân thẻ luôn ở cuối.
        main.appendChild(foot);
        var addBtnNow = foot.querySelector('.cl-preview-btn--primary');
        if (addBtnNow) addBtnNow.disabled = !cartButton();
      }
    }

    /*
      Cờ "đang mở" cho nút Preview.

      Customily mất ~250-300ms dựng ảnh rồi mới lật modal sang display:flex, và
      trong quãng đó nó không đổi gì trên nút. Đánh dấu ngay lúc bấm để CSS có
      cái mà bám vào.

      Bắt ở tầng capture trên document: nút do app dựng sau khi widget nạp xong
      nên không thể gắn listener thẳng vào nó lúc script này chạy.
    */
    var OPEN_FLAG = 'data-cl-opening';
    var openTimer = null;

    function clearOpening() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      var marked = document.querySelectorAll('[' + OPEN_FLAG + ']');
      for (var i = 0; i < marked.length; i++) marked[i].removeAttribute(OPEN_FLAG);
    }

    function markOpening(btn) {
      btn.setAttribute(OPEN_FLAG, '');
      if (openTimer) clearTimeout(openTimer);
      /*
        LƯỚI AN TOÀN BẮT BUỘC PHẢI CÓ. App CHẶN mở modal khi còn ô bắt buộc chưa
        điền — lúc đó không có modal nào hiện lên cả, nên không có gì gỡ cờ và
        nút sẽ quay mãi mãi, lại còn `pointer-events: none` nên bấm lại cũng
        không được. 1,5 giây là rộng rãi so với 300ms đo được.
      */
      openTimer = setTimeout(clearOpening, 1500);
    }

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var btn = t.closest('.customily-preview-button, #customily-preview-button');
        if (btn) markOpening(btn);
      },
      true
    );

    function isVisible(modal) {
      return modal.style.display !== 'none' && getComputedStyle(modal).display !== 'none';
    }

    function watch(modal) {
      if (modal.dataset.clWatched) return;
      modal.dataset.clWatched = '1';

      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');

      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal(modal);      // chỉ khi bấm trúng nền
      });

      new MutationObserver(function () {
        if (!isVisible(modal)) return;
        clearOpening();
        buildFrame(modal);
      }).observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });

      if (isVisible(modal)) {
        clearOpening();
        buildFrame(modal);
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var modal = document.querySelector(MODAL_SEL);
      if (modal && isVisible(modal)) { e.preventDefault(); closeModal(modal); }
    });

    var existing = document.querySelector(MODAL_SEL);
    if (existing) watch(existing);

    // App dựng modal sau khi widget nạp xong, nên vẫn phải chờ node xuất hiện.
    new MutationObserver(function () {
      var modal = document.querySelector(MODAL_SEL);
      if (modal) watch(modal);
    }).observe(document.body, { childList: true, subtree: true });
  })();
